import React, { useState } from "react";
import { Menu, Popover, Position, Card, Icon } from "@chaser/components";
import useEvent from "../../../hooks/useEvent";
import SupportModal from "../../SupportModal";
import useModal from "../../../hooks/useModal";
import style from "./SupportMenu.module.scss";

const SupportMenu = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const showModal = useModal();

  function showSupportModal(arg) {
    showModal(
      <SupportModal
        initialSubject={arg?.subject}
        disableSubject={arg?.disableSubject}
      />,
    );
  }

  function showSupportMenu() {
    setDropdownOpen(!dropdownOpen);
  }

  useEvent("openSupportModal", showSupportModal);

  return (
    <Popover
      position={Position.BOTTOM_RIGHT}
      onToggle={showSupportMenu}
      target={
        <div className={style.notificationButton}>
          <Icon name="help" size={24} data-tour="support-menu" />
        </div>
      }
    >
      <Card>
        <Menu>
          <Menu.Item
            as="a"
            href="https://www.chaserhq.com/guide/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Getting started
          </Menu.Item>
          <Menu.Item
            as="a"
            href="https://help.chaserhq.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Center
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            onClick={() => {
              showSupportModal();
            }}
          >
            Contact support
          </Menu.Item>
        </Menu>
      </Card>
    </Popover>
  );
};

export default SupportMenu;
